import { RawDraftContentState } from 'draft-js';
import React, { useCallback, useMemo } from 'react';

import { useAppDispatch } from '../../../hooks/react-redux';
import { Mail } from '../../shared/icons';
import { ConfirmationModal } from '../../shared/modal/ConfirmationModal';
import { ModalHeader } from '../../shared/modal/ModalHeader';
import { ReportEmailContent } from '../../shared/report/ReportEmailContent';
import styles from './NettingEngine.module.scss';
import { emailNettingEngineResultsStarted, NettingResultsEmailDetails, toggleNettingResultsEmailModalOpen, updateNettingResultsEmailValue } from './store';

interface NettingResultsEmailModalProps {
    emailDetails: NettingResultsEmailDetails;
    svgDimensions: { height: number; width: number; };
}

export const NettingResultsEmailModal: React.FC<NettingResultsEmailModalProps> = ({ emailDetails, svgDimensions }) => {
    const { height, width } = svgDimensions;
    const { userIds, emailBody } = emailDetails;
    const dispatch = useAppDispatch();
    const closeModal = useCallback(() => dispatch(toggleNettingResultsEmailModalOpen(false)), [dispatch]);
    const updateSelectedUserIds = useCallback((value: number[]) => dispatch(updateNettingResultsEmailValue('userIds', value)), [dispatch]);
    const updateEmailBody = useCallback((value: RawDraftContentState | null) => dispatch(updateNettingResultsEmailValue('emailBody', value)), [dispatch]);

    const confirm = useCallback(() => dispatch(emailNettingEngineResultsStarted(height, width)), [dispatch, height, width]);
    const confirmDisabled = useMemo(() => userIds.length === 0, [userIds]);
    const confirmDisabledTooltip = useMemo(() => userIds.length === 0 ? ['You must select at least one user if you would like to send this report as an email'] : [], [userIds]);
    const testId = 'netting-results-email';

    return (
        <ConfirmationModal
            isOpen
            closeModal={closeModal}
            confirm={confirm}
            confirmDisabled={confirmDisabled}
            confirmDisabledTooltip={confirmDisabledTooltip}
            closeOnOverlayClick={false}
            spaceBetweenButtons
            confirmLabel='Send'
        >
            <div className={styles.nettingResultsEmailModal}>
                <ModalHeader
                    label='Email Netting Engine Results'
                    testId={`${testId}-modal`}
                    icon={Mail}
                />
                <ReportEmailContent emailBody={emailBody} selectedUserIds={userIds} testId={testId} updateEmailBody={updateEmailBody} updateSelectedUserIds={updateSelectedUserIds} />
            </div>
        </ ConfirmationModal>
    );
};
